import PropTypes from 'prop-types'
import React from 'react'
import { Button } from './Button'

export function Badge({ children, family = 'brand', onRemove, ...props }) {
  const className = `me-badge-tint me-badge-tint-${family}`
  if (onRemove)
    return (
      <span className={className}>
        <span>{children}</span>
        <Button
          className="me-btn-icon me-btn-icon-xs me-badge-dismiss"
          icon="fa-regular fa-xmark"
          aria-label={window.MEButtons.text('strRemoveFilter', {
            label: children,
          })}
          onClick={onRemove}
        />
      </span>
    )
  return (
    <Button {...props} className={className}>
      {children}
    </Button>
  )
}

Badge.propTypes = {
  children: PropTypes.string.isRequired,
  family: PropTypes.oneOf([
    'brand',
    'neutral',
    'success',
    'warning',
    'danger',
    'info',
  ]),
  // Renders the removable filter badge: a static label and a dismiss button.
  onRemove: PropTypes.func,
  // Only brand and neutral badges have a disabled state.
  disabled: props => {
    const disabled = props.disabled || props['aria-disabled']
    if (disabled && !['brand', 'neutral'].includes(props.family || 'brand'))
      return new Error('Only brand and neutral badges have a disabled state.')
    return null
  },
}
